// extracted by mini-css-extract-plugin
export default {"productGallery":"QM-z","inQuickShop":"RM-z"};